import LegalLayout from './LegalLayout';

export default function CookiesPolicy() {
  return (
    <LegalLayout title="Cookies y Almacenamiento Local" updatedAt="febrero 2026">
      <p>
        Esta política explica qué información almacena el sitio <b>priviax.cl</b> en el navegador de
        quienes lo utilizan, con qué finalidad y cómo puede controlarla. Está redactada conforme al
        <b> art. 14 de la Ley N.º 21.719</b> (principio de transparencia y medidas de seguridad
        razonables).
      </p>

      <h2>1. ¿Priviax usa cookies HTTP?</h2>
      <p>
        <b>No directamente.</b> Priviax utiliza <code>localStorage</code> del navegador (un
        almacenamiento técnico local) en lugar de cookies HTTP tradicionales. Para efectos de esta
        política y del propio módulo CMP de Priviax, tratamos <b>ambos mecanismos como equivalentes</b>:
        cualquier dato guardado en su navegador se declara aquí.
      </p>

      <h2>2. Qué guardamos y por qué</h2>
      <div className="my-4 border border-[#E5E7EB] overflow-x-auto">
        <table className="w-full text-[13.5px]">
          <thead className="bg-[#FAFBFC]">
            <tr>
              <th className="text-left px-3 py-2 border-b border-[#E5E7EB] font-semibold text-[11px] uppercase tracking-wider text-[#6B7280]">Clave</th>
              <th className="text-left px-3 py-2 border-b border-[#E5E7EB] font-semibold text-[11px] uppercase tracking-wider text-[#6B7280]">Contenido</th>
              <th className="text-left px-3 py-2 border-b border-[#E5E7EB] font-semibold text-[11px] uppercase tracking-wider text-[#6B7280]">Categoría</th>
              <th className="text-left px-3 py-2 border-b border-[#E5E7EB] font-semibold text-[11px] uppercase tracking-wider text-[#6B7280]">Duración</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><code>priviax_token</code></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">JWT de sesión firmado</td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><b>Necesaria</b></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">7 días o logout</td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><code>priviax_memberships</code></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Lista de organizaciones a las que pertenece</td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><b>Necesaria</b></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Hasta logout</td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><code>priviax_active_org_id</code></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Organización activa (multi-org)</td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><b>Necesaria</b></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Hasta logout</td>
            </tr>
            <tr>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><code>priviax_last_org_selection</code></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Fecha del último selector de organización</td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]"><b>Necesaria</b></td>
              <td className="px-3 py-2 border-b border-[#E5E7EB]">Hasta logout</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>3. Categorías y base legal</h2>
      <ul>
        <li>
          <b>Estrictamente necesarias:</b> las 4 anteriores. Son imprescindibles para autenticarle,
          mantener su sesión y respetar su elección de organización activa. Base legal: {' '}
          <i>ejecución de contrato</i> (art. 12 letra b Ley 21.719). No requieren consentimiento
          previo.
        </li>
        <li>
          <b>Funcionales:</b> no usamos hoy.
        </li>
        <li>
          <b>Analíticas:</b> no usamos hoy. Si en el futuro incorporamos herramientas de analítica
          (por ejemplo, Plausible o Fathom sin tracking cross-site), aparecerá un banner de
          consentimiento antes de activarlas y esta política se actualizará.
        </li>
        <li>
          <b>Publicitarias / Marketing:</b> <b>Priviax no utiliza cookies publicitarias</b> ni de
          seguimiento entre sitios. Nunca compartimos su navegación con redes de anuncios.
        </li>
      </ul>

      <h2>4. ¿Cómo puedo borrarlas?</h2>
      <p>
        Puede borrar el <code>localStorage</code> de priviax.cl en cualquier momento desde su
        navegador:
      </p>
      <ul>
        <li><b>Chrome:</b> DevTools (F12) → Application → Storage → Local Storage → priviax.cl → clic derecho → Clear.</li>
        <li><b>Firefox:</b> DevTools (F12) → Storage → Local Storage → priviax.cl → clic derecho → Delete All.</li>
        <li><b>Safari:</b> Preferencias → Privacidad → Gestionar datos de sitios web → priviax.cl → Eliminar.</li>
        <li>Alternativa universal: cerrar sesión con el botón <b>Cerrar sesión</b> de la aplicación.</li>
      </ul>
      <p>
        Borrar los datos necesarios le cerrará la sesión y deberá volver a iniciarla.
      </p>

      <h2>5. Terceros que sí usan cookies durante la operación del Servicio</h2>
      <p>
        Ciertos flujos externos pueden establecer cookies propias fuera de nuestro control:
      </p>
      <ul>
        <li><b>Stripe</b> (cuando active pagos): cookies propias de Stripe para prevención de fraude durante el checkout. Ver <a href="https://stripe.com/cookies-policy" target="_blank" rel="noreferrer">stripe.com/cookies-policy</a>.</li>
        <li><b>Resend</b> (correos transaccionales): puede incluir un pixel de tracking en algunos emails para saber si se abrieron. Esto no ocurre en el sitio web.</li>
      </ul>

      <h2>6. Cambios a esta política</h2>
      <p>
        Cualquier cambio (por ejemplo, cuando activemos analíticas) se publicará en esta misma URL
        con nueva fecha de actualización. Si se agregan cookies no-necesarias, aparecerá primero un
        banner de consentimiento explícito.
      </p>

      <h2>7. Contacto</h2>
      <p>
        <b>Auttobots SpA</b> · RUT 77.674.834-K · Cerro el Plomo 5931 Of. 1213, Las Condes, Santiago, Chile ·{' '}
        <a href="mailto:hola@priviax.cl">hola@priviax.cl</a>.
      </p>
    </LegalLayout>
  );
}
